/**
 * DashboardEvalToSessionChart (iter 277)
 *
 * Dashboard-only version of the Eval → Therapy trend with a scope
 * toggle: All clinics vs a specific clinic. Sits BEFORE the Cohort
 * Conversion table.
 */
import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import MonthlyTrendChart from './MonthlyTrendChart';

export default function DashboardEvalToSessionChart() {
  const [scope, setScope] = useState('all');
  const [clinics, setClinics] = useState([]);
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get('/clinics').then((r) => {
      setClinics(Array.isArray(r.data) ? r.data.map((c) => c.name || c.clinic).filter(Boolean) : []);
    }).catch(() => {});
  }, []);
  useEffect(() => {
    api.get('/dashboard/eval-to-session', { params: { scope, months: 13 } })
      .then((r) => setData(r.data))
      .catch(() => setData({ months: [] }));
  }, [scope]);
  if (!data) return null;
  const months = (data.months || []).map((m) => ({ ...m, value: m.eval_to_therapy_pct }));

  return (
    <div className="mb-4" data-testid="dashboard-eval-to-session">
      <div className="flex items-center justify-end gap-2 mb-2">
        <label htmlFor="ets-scope" className="text-[10px] uppercase tracking-widest font-semibold" style={{ color: '#685B72' }}>Scope</label>
        <select
          id="ets-scope"
          value={scope}
          onChange={(e) => setScope(e.target.value)}
          className="h-8 px-3 rounded-full border text-[12px] bg-white"
          style={{ borderColor: '#685B72', color: '#2D2833' }}
          data-testid="dashboard-eval-to-session-scope"
        >
          <option value="all">All clinics</option>
          {clinics.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>
      <MonthlyTrendChart
        title="Eval → Therapy Started"
        subtitle={scope === 'all' ? 'Group-wide · of evals completed each month, % that started therapy' : `${scope} · of evals completed each month, % that started therapy`}
        data={months}
        color="#839E97"
        format="pct"
        yDomain={[0, 1]}
        height={240}
        testid="dashboard-eval-to-session-chart"
      />
    </div>
  );
}
